import type { IInfoPopupProps } from './index.h'

import { INFO_BUTTON_CLASS } from '@setplex/pureya'
import { createEvent, createStore } from 'effector'
import { register } from '~/core/repository'
import { $popup } from './translations'

export const openInfoPopup = createEvent<IInfoPopupProps>()

const emptyState = {
  condition: false,
  episodeId: null,
  description: null,
  directors: null,
  stars: null,
  resolution: null,
  length: null,
  eventDate: null,
  releaseYear: null,
  duration: null,
  ageRating: null,
  title: null,
  name: null,
  labels: null,
  eventDescription: null,
  quality: null,
  dolbyAtmos: null,
}

export const closeInfoPopup = createEvent()
export const toggleInfoPopup = createEvent<IInfoPopupProps | undefined>()

export const $infoPopup = createStore<IInfoPopupProps>(emptyState)
  .on(openInfoPopup, (_, payload) => ({ ...payload, condition: true }))
  .on(closeInfoPopup, () => emptyState)
  .on(toggleInfoPopup, (state, payload) => {
    if (!state.condition && payload) return { ...payload, condition: true }
    return emptyState
  })

register($popup, '$popup')
register($infoPopup, '$infoPopup')
register(openInfoPopup, 'openInfoPopup')
register(closeInfoPopup, 'closeInfoPopup')
register(createStore(INFO_BUTTON_CLASS), '$info-popup/toggleClassName')
